import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ElementRef,
  ViewChild,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UserBasic } from 'src/app/_models/user.model';
import { UserService } from 'src/app/_services';

@Component({
  selector: 'app-select-user',
  templateUrl: './select-user.component.html',
  styleUrls: ['./select-user.component.scss'],
})
export class SelectUserComponent implements OnInit {
  @Input()
  public label: string = this.translateServ.instant('SELECT_USER');

  @Input()
  selectedUser: UserBasic = new UserBasic();

  @Input()
  formControlName: string;

  @Input()
  formControl: FormControl = null;

  @Input()
  disabled: boolean;

  @Input()
  class: boolean;

  @Input()
  filtrIdCompany: number;

  @Input()
  selectCurrentUser: boolean = false;

  @Input()
  removeCurrentUserFromList: boolean = false;

  @Input()
  data: UserBasic[];

  @Input()
  allowClear = true;

  @Input()
  multipleSelection: boolean = false;

  @Input()
  allUserSelection: boolean = false;

  @Output()
  changeValueEvent: EventEmitter<UserBasic> = new EventEmitter<UserBasic>();

  userView = [];
  selectedUserId: number = undefined;

  allUsers: UserBasic = {
    ...new UserBasic(),
    id: null,
    email: this.translateServ.instant('SPACE.All_EMPLOYEES'),
  };

  constructor(
    public userServ: UserService,
    public translateServ: TranslateService
  ) {}

  async ngOnInit() {
    this.formControl?.valueChanges.subscribe();

    if (!this.data) {
      await this.userServ
        .getActiveSync(true, this.filtrIdCompany)
        .finally(() => {
          this.data = this.allUserSelection ? 
            [this.allUsers, ...this.userServ.users] : 
            [...this.userServ.users] ;
        });
    }

    if (this.removeCurrentUserFromList) {
      this.data = this.data.filter(
        (x) => x.id !== this.userServ.userStorage.id
      );
    }

    if (this.selectCurrentUser) {
      this.setUser(this.userServ.userStorage.id);
    }

    this.userView = this.data.map((user) => {
      if (user.email === this.translateServ.instant('SPACE.ALL_USERS'))
        return {
          id: user.id,
          text: user.email,
        };
      return {
        id: user.id,
        text: `${user?.firstName ? user?.firstName : ''} ${user?.lastName ? user?.lastName : ''} ${user?.company?.name ? user?.company?.name : ''}\n${user.email ? user.email : ''}`,
      };
    });

    this.changeDisabled();
  }

  userChange(user) {
    this.setUser(user);
    this.changeValueEvent.emit(this.selectedUser);
    this.userServ.userBasic = this.selectedUser;
  }

  userRemove() {
    this.selectedUser = null;
    this.selectedUserId = null;
    this.userServ.userBasic = null;
    this.changeValueEvent.emit(null);
  }

  setUser(id) {
    if (!id) id = null;

    this.selectedUserId = id;
    this.selectedUser = this.data.find((user) => user.id == id);
  }

  changeDisabled() {
    setTimeout(() => {
      const toggle = document.getElementsByClassName('ngx-select__toggle')[0];
      const placeholder = document.getElementsByClassName(
        'ngx-select__placeholder'
      )[0];
      if (this.disabled) {
        toggle.setAttribute('style', 'background: #e9ecef;');
        placeholder.setAttribute('style', ' color: #333 !important');
      } else {
        toggle.setAttribute('style', 'background: #fff');
        placeholder.setAttribute('style', '');
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.disabled.currentValue != changes.disabled.previousValue) {
      this.changeDisabled();
    }
  }
}
